import { createFeature, createReducer, on } from '@ngrx/store';

import { Tenant } from '../models';
import { TenantsActions } from './tenants.actions';

export interface TenantsState {
  readonly tenants: Tenant[];
  readonly env: string | null;
  readonly loading: boolean;
  readonly saving: boolean;
  readonly error: string | null;
}

export const initialState: TenantsState = {
  tenants: [],
  env: null,
  loading: false,
  saving: false,
  error: null,
};

export const tenantsFeature = createFeature({
  name: 'tenants',
  reducer: createReducer(
    initialState,

    on(TenantsActions.load, (state) => ({ ...state, loading: true, error: null })),
    on(TenantsActions.loadSuccess, (state, { tenants, env }) => ({
      ...state,
      tenants,
      env,
      loading: false,
    })),
    on(TenantsActions.loadFailure, (state, { error }) => ({ ...state, loading: false, error })),

    on(TenantsActions.saveTenant, (state) => ({ ...state, saving: true, error: null })),
    on(TenantsActions.saveTenantSuccess, (state, { tenant }) => ({
      ...state,
      saving: false,
      tenants: state.tenants.map((t) => (t.tenantId === tenant.tenantId ? tenant : t)),
    })),
    on(TenantsActions.saveTenantFailure, (state, { error }) => ({
      ...state,
      saving: false,
      error,
    })),

    on(TenantsActions.tenantChanged, (state, { tenant }) => ({
      ...state,
      tenants: state.tenants.some((t) => t.tenantId === tenant.tenantId)
        ? state.tenants.map((t) => (t.tenantId === tenant.tenantId ? tenant : t))
        : [...state.tenants, tenant],
    })),
  ),
});
